const LEGACY_NORMALIZED_FLAG = '__legacyNormalized__'

export const markLegacyNormalized = (target: Record<string, any>) => {
  if (!target || typeof target !== 'object') return
  if ((target as any)[LEGACY_NORMALIZED_FLAG]) return
  Object.defineProperty(target, LEGACY_NORMALIZED_FLAG, {
    value: true,
    enumerable: false,
    configurable: true,
    writable: false,
  })
}

export const isLegacyNormalized = (target: Record<string, any>) =>
  !!(target && typeof target === 'object' && (target as any)[LEGACY_NORMALIZED_FLAG])
